import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Phase',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Change Impacts by Phase',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'discovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'design',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'bioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'giftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'memberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'givingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'prospectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'stewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'backlog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'testing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'training',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Phase',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    design: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Design',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    backlog: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Backlog',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bioDemo: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Bio Demo',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    testing: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Testing',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    training: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Training',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    discovery: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Discovery',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    memberships: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Memberships',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    stewardship: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Stewardship',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    giftsAndPledges: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Gifts & Pledges',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    givingSocieties: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Giving Societies',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    prospectResearchAndManagement: {
      filter: {
        '=': [
          {
            '@.': '!phase',
          },
          'Prospect Research & Management',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
